var countries =  [
    {
        "Code": "AFG",
        "Description": "Afghanistan"
    },
    {
        "Code": "ALB",
        "Description": "Albania"
    },
    {
        "Code": "DZA",
        "Description": "Algeria"
    },
    {
        "Code": "AND",
        "Description": "Andorra"
    },
    {
        "Code": "AGO",
        "Description": "Angola"
    },
    {
        "Code": "ATG",
        "Description": "Antigua and barbuda"
    },
    {
        "Code": "ARG",
        "Description": "Argentina"
    },
    {
        "Code": "ARM",
        "Description": "Armenia"
    },
    {
        "Code": "AUS",
        "Description": "Australia"
    },
    {
        "Code": "AUT",
        "Description": "Austria"
    },
    {
        "Code": "AZE",
        "Description": "Azerbaijan"
    },
    {
        "Code": "BHS",
        "Description": "Bahamas"
    },
    {
        "Code": "BHR",
        "Description": "Bahrain"
    },
    {
        "Code": "BGD",
        "Description": "Bangladesh"
    },
    {
        "Code": "BRB",
        "Description": "Barbados"
    },
    {
        "Code": "BLR",
        "Description": "Belarus"
    },
    {
        "Code": "BEL",
        "Description": "Belgium"
    },
    {
        "Code": "BLZ",
        "Description": "Belize"
    },
    {
        "Code": "BEN",
        "Description": "Benin"
    },
    {
        "Code": "BTN",
        "Description": "Bhutan"
    },
    {
        "Code": "BOL",
        "Description": "Bolivia, plurinational state of"
    },
    {
        "Code": "BIH",
        "Description": "Bosnia and herzegovina"
    },
    {
        "Code": "BWA",
        "Description": "Botswana"
    },
    {
        "Code": "BRA",
        "Description": "Brazil"
    },
    {
        "Code": "BRN",
        "Description": "Brunei"
    },
    {
        "Code": "BGR",
        "Description": "Bulgaria"
    },
    {
        "Code": "BFA",
        "Description": "Burkina faso"
    },
    {
        "Code": "MMR",
        "Description": "Burma (myanmar)"
    },
    {
        "Code": "BDI",
        "Description": "Burundi"
    },
    {
        "Code": "KHM",
        "Description": "Cambodia"
    },
    {
        "Code": "CMR",
        "Description": "Cameroon"
    },
    {
        "Code": "CAN",
        "Description": "Canada"
    },
    {
        "Code": "CPV",
        "Description": "Cape verde"
    },
    {
        "Code": "CAF",
        "Description": "Central african republic"
    },
    {
        "Code": "TCD",
        "Description": "Chad"
    },
    {
        "Code": "CHL",
        "Description": "Chile"
    },
    {
        "Code": "CHN",
        "Description": "China"
    },
    {
        "Code": "COL",
        "Description": "Colombia"
    },
    {
        "Code": "COM",
        "Description": "Comoros"
    },
    {
        "Code": "COD",
        "Description": "Congo, democratic republic of the"
    },
    {
        "Code": "COG",
        "Description": "Congo, republic of the"
    },
    {
        "Code": "CRI",
        "Description": "Costa rica"
    },
    {
        "Code": "CIV",
        "Description": "Cote d'ivoire (ivory coast)"
    },
    {
        "Code": "HRV",
        "Description": "Croatia"
    },
    {
        "Code": "CUB",
        "Description": "Cuba"
    },
    {
        "Code": "CYP",
        "Description": "Cyprus"
    },
    {
        "Code": "CZE",
        "Description": "Czech republic"
    },
    {
        "Code": "DNK",
        "Description": "Denmark"
    },
    {
        "Code": "DJI",
        "Description": "Djibouti"
    },
    {
        "Code": "DMA",
        "Description": "Dominica"
    },
    {
        "Code": "DOM",
        "Description": "Dominican republic"
    },
    {
        "Code": "ECU",
        "Description": "Ecuador"
    },
    {
        "Code": "EGY",
        "Description": "Egypt"
    },
    {
        "Code": "SLV",
        "Description": "El salvador"
    },
    {
        "Code": "GNQ",
        "Description": "Equatorial guinea"
    },
    {
        "Code": "ERI",
        "Description": "Eritrea"
    },
    {
        "Code": "EST",
        "Description": "Estonia"
    },
    {
        "Code": "SWZ",
        "Description": "Eswatini"
    },
    {
        "Code": "ETH",
        "Description": "Ethiopia"
    },
    {
        "Code": "FJI",
        "Description": "Fiji"
    },
    {
        "Code": "FIN",
        "Description": "Finland"
    },
    {
        "Code": "FRA",
        "Description": "France"
    },
    {
        "Code": "GAB",
        "Description": "Gabon"
    },
    {
        "Code": "GMB",
        "Description": "Gambia"
    },
    {
        "Code": "GEO",
        "Description": "Georgia"
    },
    {
        "Code": "DEU",
        "Description": "Germany"
    },
    {
        "Code": "GHA",
        "Description": "Ghana"
    },
    {
        "Code": "GRC",
        "Description": "Greece"
    },
    {
        "Code": "GRD",
        "Description": "Grenada"
    },
    {
        "Code": "GTM",
        "Description": "Guatemala"
    },
    {
        "Code": "GIN",
        "Description": "Guinea"
    },
    {
        "Code": "GNB",
        "Description": "Guinea-bissau"
    },
    {
        "Code": "GUY",
        "Description": "Guyana"
    },
    {
        "Code": "HTI",
        "Description": "Haiti"
    },
    {
        "Code": "VAT",
        "Description": "Holy see (vatican city state)"
    },
    {
        "Code": "HND",
        "Description": "Honduras"
    },
    {
        "Code": "HUN",
        "Description": "Hungary"
    },
    {
        "Code": "ISL",
        "Description": "Iceland"
    },
    {
        "Code": "IND",
        "Description": "India"
    },
    {
        "Code": "IDN",
        "Description": "Indonesia"
    },
    {
        "Code": "IRN",
        "Description": "Iran, islamic republic of"
    },
    {
        "Code": "IRQ",
        "Description": "Iraq"
    },
    {
        "Code": "IRL",
        "Description": "Ireland"
    },
    {
        "Code": "ISR",
        "Description": "Israel"
    },
    {
        "Code": "ITA",
        "Description": "Italy"
    },
    {
        "Code": "JAM",
        "Description": "Jamaica"
    },
    {
        "Code": "JPN",
        "Description": "Japan"
    },
    {
        "Code": "JOR",
        "Description": "Jordan"
    },
    {
        "Code": "KAZ",
        "Description": "Kazakhstan"
    },
    {
        "Code": "KEN",
        "Description": "Kenya"
    },
    {
        "Code": "KIR",
        "Description": "Kiribati"
    },
    {
        "Code": "PRK",
        "Description": "Korea, democratic republic of (north)"
    },
    {
        "Code": "KOR",
        "Description": "Korea, republic of (south)"
    },
    {
        "Code": "KVO",
        "Description": "Kosovo"
    },
    {
        "Code": "KWT",
        "Description": "Kuwait"
    },
    {
        "Code": "KGZ",
        "Description": "Kyrgyzstan"
    },
    {
        "Code": "LAO",
        "Description": "Laos"
    },
    {
        "Code": "LVA",
        "Description": "Latvia"
    },
    {
        "Code": "LBN",
        "Description": "Lebanon"
    },
    {
        "Code": "LSO",
        "Description": "Lesotho"
    },
    {
        "Code": "LBR",
        "Description": "Liberia"
    },
    {
        "Code": "LBY",
        "Description": "Libya"
    },
    {
        "Code": "LIE",
        "Description": "Liechtenstein"
    },
    {
        "Code": "LTU",
        "Description": "Lithuania"
    },
    {
        "Code": "LUX",
        "Description": "Luxembourg"
    },
    {
        "Code": "MKD",
        "Description": "Macedonia, North"
    },
    {
        "Code": "MDG",
        "Description": "Madagascar"
    },
    {
        "Code": "MWI",
        "Description": "Malawi"
    },
    {
        "Code": "MYS",
        "Description": "Malaysia"
    },
    {
        "Code": "MDV",
        "Description": "Maldives"
    },
    {
        "Code": "MLI",
        "Description": "Mali"
    },
    {
        "Code": "MLT",
        "Description": "Malta"
    },
    {
        "Code": "MHL",
        "Description": "Marshall islands, republic of the"
    },
    {
        "Code": "MRT",
        "Description": "Mauritania"
    },
    {
        "Code": "MUS",
        "Description": "Mauritius"
    },
    {
        "Code": "MEX",
        "Description": "Mexico"
    },
    {
        "Code": "FSM",
        "Description": "Micronesia, federated states of"
    },
    {
        "Code": "MDA",
        "Description": "Moldova, republic of"
    },
    {
        "Code": "MCO",
        "Description": "Monaco"
    },
    {
        "Code": "MNG",
        "Description": "Mongolia"
    },
    {
        "Code": "MNE",
        "Description": "Montenegro"
    },
    {
        "Code": "MAR",
        "Description": "Morocco"
    },
    {
        "Code": "MOZ",
        "Description": "Mozambique"
    },
    {
        "Code": "NAM",
        "Description": "Namibia"
    },
    {
        "Code": "NRU",
        "Description": "Nauru"
    },
    {
        "Code": "NPL",
        "Description": "Nepal"
    },
    {
        "Code": "NLD",
        "Description": "Netherlands"
    },
    {
        "Code": "NZL",
        "Description": "New zealand"
    },
    {
        "Code": "NIC",
        "Description": "Nicaragua"
    },
    {
        "Code": "NER",
        "Description": "Niger"
    },
    {
        "Code": "NGA",
        "Description": "Nigeria"
    },
    {
        "Code": "NOR",
        "Description": "Norway"
    },
    {
        "Code": "OMN",
        "Description": "Oman"
    },
    {
        "Code": "PAK",
        "Description": "Pakistan"
    },
    {
        "Code": "PLW",
        "Description": "Palau"
    },
    {
        "Code": "PSE",
        "Description": "Palestinian authority"
    },
    {
        "Code": "PAN",
        "Description": "Panama"
    },
    {
        "Code": "PNG",
        "Description": "Papua new guinea"
    },
    {
        "Code": "PRY",
        "Description": "Paraguay"
    },
    {
        "Code": "PER",
        "Description": "Peru"
    },
    {
        "Code": "PHL",
        "Description": "Philippines"
    },
    {
        "Code": "POL",
        "Description": "Poland"
    },
    {
        "Code": "PRT",
        "Description": "Portugal"
    },
    {
        "Code": "QAT",
        "Description": "Qatar"
    },
    {
        "Code": "ROU",
        "Description": "Romania"
    },
    {
        "Code": "RUS",
        "Description": "Russia"
    },
    {
        "Code": "RWA",
        "Description": "Rwanda"
    },
    {
        "Code": "KNA",
        "Description": "Saint kitts and nevis"
    },
    {
        "Code": "LCA",
        "Description": "Saint lucia"
    },
    {
        "Code": "VCT",
        "Description": "Saint vincent and the grenadines"
    },
    {
        "Code": "WSM",
        "Description": "Samoa"
    },
    {
        "Code": "SMR",
        "Description": "San marino"
    },
    {
        "Code": "STP",
        "Description": "Sao tome and principe"
    },
    {
        "Code": "SAU",
        "Description": "Saudi arabia"
    },
    {
        "Code": "SEN",
        "Description": "Senegal"
    },
    {
        "Code": "SRB",
        "Description": "Serbia"
    },
    {
        "Code": "SYC",
        "Description": "Seychelles"
    },
    {
        "Code": "SLE",
        "Description": "Sierra leone"
    },
    {
        "Code": "SGP",
        "Description": "Singapore"
    },
    {
        "Code": "SVK",
        "Description": "Slovakia"
    },
    {
        "Code": "SVN",
        "Description": "Slovenia"
    },
    {
        "Code": "SLB",
        "Description": "Solomon islands"
    },
    {
        "Code": "SOM",
        "Description": "Somalia"
    },
    {
        "Code": "ZAF",
        "Description": "South Africa"
    },
    {
        "Code": "SSD",
        "Description": "South Sudan"
    },
    {
        "Code": "ESP",
        "Description": "Spain"
    },
    {
        "Code": "LKA",
        "Description": "Sri lanka"
    },
    {
        "Code": "SDN",
        "Description": "Sudan"
    },
    {
        "Code": "SUR",
        "Description": "Suriname"
    },
    {
        "Code": "SWZ",
        "Description": "Swaziland"
    },
    {
        "Code": "SWE",
        "Description": "Sweden"
    },
    {
        "Code": "CHE",
        "Description": "Switzerland"
    },
    {
        "Code": "SYR",
        "Description": "Syria"
    },
    {
        "Code": "TWN",
        "Description": "Taiwan"
    },
    {
        "Code": "TJK",
        "Description": "Tajikistan"
    },
    {
        "Code": "TZA",
        "Description": "Tanzania, united republic of"
    },
    {
        "Code": "THA",
        "Description": "Thailand"
    },
    {
        "Code": "TLS",
        "Description": "Timor-leste"
    },
    {
        "Code": "TGO",
        "Description": "Togo"
    },
    {
        "Code": "TON",
        "Description": "Tonga"
    },
    {
        "Code": "TTO",
        "Description": "Trinidad and Tobago"
    },
    {
        "Code": "TUN",
        "Description": "Tunisia"
    },
    {
        "Code": "TUR",
        "Description": "Turkey"
    },
    {
        "Code": "TKM",
        "Description": "Turkmenistan"
    },
    {
        "Code": "TUV",
        "Description": "Tuvalu"
    },
    {
        "Code": "UGA",
        "Description": "Uganda"
    },
    {
        "Code": "UKR",
        "Description": "Ukraine"
    },
    {
        "Code": "ARE",
        "Description": "United Arab Emirates"
    },
    {
        "Code": "GBR",
        "Description": "United Kingdom"
    },
    {
        "Code": "URY",
        "Description": "Uruguay"
    },
    {
        "Code": "UZB",
        "Description": "Uzbekistan"
    },
    {
        "Code": "VUT",
        "Description": "Vanuatu"
    },
    {
        "Code": "VEN",
        "Description": "Venezuela, bolivarian republic of"
    },
    {
        "Code": "VNM",
        "Description": "Viet nam"
    },
    {
        "Code": "YEM",
        "Description": "Yemen"
    },
    {
        "Code": "ZMB",
        "Description": "Zambia"
    },
    {
        "Code": "ZWE",
        "Description": "Zimbabwe"
    }
];

if (typeof window !== "undefined") {
    window.countries = countries;
}

try {
    module.exports = countries;
} catch (e) {
}
